"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jun 29 2018
 */

var AppModule_1 = require("../core/modules/AppModule");

var TierConverter_1 = require("./conversions/TierConverter");

var TierConverterImpl_1 = require("./conversions/TierConverterImpl");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PriceArchitectureDTOConverter_1 = require("./conversions/PriceArchitectureDTOConverter");

var PriceArchitectureDTOConverterImpl_1 = require("./conversions/PriceArchitectureDTOConverterImpl");
/**
 * Configures tier app module
 */


var TierAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(TierAppModule, _AppModule_1$AppModul);

  function TierAppModule() {
    var _this;

    _classCallCheck(this, TierAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TierAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'tierAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(TierAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(PriceArchitectureDTOConverter_1.PriceArchitectureDTOConverter).to(PriceArchitectureDTOConverterImpl_1.PriceArchitectureDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(TierConverter_1.TierConverter).to(TierConverterImpl_1.TierConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return TierAppModule;
}(AppModule_1.AppModule);

exports.TierAppModule = TierAppModule;